import HttpService, { BaseResponse } from "../base";
import {
  CollateralStrategyRow,
  VirtualOmsEventLogRow,
} from "src/VirtualOMS/types/collateral";

class CollateralProvider extends HttpService {
  constructor() {
    super({ suffix: "Order" });
  }

  public getStrategies(userId: number): BaseResponse<CollateralStrategyRow[]> {
    return this.httpService.get("CollateralStrategies", {
      params: { userId },
    });
  }

  public clearStrategies(userId: number): BaseResponse<void> {
    return this.httpService.delete("CollateralStrategies", {
      params: { userId },
    });
  }

  public getEventLogs(userId: number): BaseResponse<VirtualOmsEventLogRow[]> {
    return this.httpService.get("EventLogs", {
      params: { userId },
    });
  }

  public clearEventLogs(userId: number): BaseResponse<void> {
    return this.httpService.delete("EventLogs", {
      params: { userId },
    });
  }
}

const CollateralService = new CollateralProvider();

export default CollateralService;
